if (!customElements.get('cart-shipping-bar')) {
  class CartShippingBar extends HTMLElement {
    constructor() {
      super();

      this.thresholdCents = parseInt(this.dataset.thresholdCents, 10) || 0;

      this.track = this.querySelector('[data-free-shipping-track]');
      this.fill = this.querySelector('[data-free-shipping-fill]');
      this.amount = this.querySelector('[data-free-shipping-amount]');
      this.awayMessage = this.querySelector('[data-free-shipping-away]');
      this.qualifiedMessage = this.querySelector('[data-free-shipping-qualified]');

      this._onCartUpdated = this._handleCartUpdated.bind(this);
      this._onAjaxProductAdded = this._handleAjaxProductAdded.bind(this);
    }

    connectedCallback() {
      if (!this.thresholdCents) {
        return;
      }

      document.addEventListener('cart:updated', this._onCartUpdated);
      // 'cart:updated' is only dispatched from quantity changes; add-to-cart
      // flows (ajaxProduct:added) rebuild the drawer without that event, so
      // fetch the fresh cart total in that case.
      document.addEventListener('ajaxProduct:added', this._onAjaxProductAdded);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
      document.removeEventListener('ajaxProduct:added', this._onAjaxProductAdded);
    }

    _handleCartUpdated(event) {
      var cart = event && event.detail && event.detail.cart;

      if (!cart || typeof cart.total_price === 'undefined') {
        return;
      }

      this.update(cart.total_price);
    }

    _handleAjaxProductAdded() {
      if (!window.theme || !window.theme.cart || !window.theme.cart.getCart) {
        return;
      }

      window.theme.cart.getCart().then(function(cart) {
        if (cart && typeof cart.total_price !== 'undefined') {
          this.update(cart.total_price);
        }
      }.bind(this)).catch(function() {});
    }

    update(totalPriceCents) {
      if (!this.thresholdCents) {
        return;
      }

      var remaining = this.thresholdCents - totalPriceCents;
      var qualified = remaining <= 0;
      var percent = Math.min(100, Math.max(0, (totalPriceCents / this.thresholdCents) * 100));

      if (this.fill) {
        this.fill.style.width = percent + '%';
      }

      if (this.track) {
        this.track.setAttribute('aria-valuenow', Math.round(percent));
      }

      if (this.amount && !qualified && window.theme && window.theme.Currency) {
        var moneyFormat = window.theme.settings ? window.theme.settings.moneyFormat : undefined;
        this.amount.innerHTML = window.theme.Currency.formatMoney(remaining, moneyFormat);
      }

      if (this.awayMessage) {
        this.awayMessage.hidden = qualified;
      }

      if (this.qualifiedMessage) {
        this.qualifiedMessage.hidden = !qualified;
      }
    }
  }

  customElements.define('cart-shipping-bar', CartShippingBar);
}